// optionsSlice.js
import { v4 as uuidv4 } from 'uuid';

export const createOptionsSlice = (set, get) => ({
  // Option management for choice questions
  addOption: (questionId, optionText = 'New Option') =>
    set((state) => {
      const questions = state.questions.map((q) => {
        if (q.id === questionId && q.options) {
          const newOption = {
            id: uuidv4(),
            text: optionText,
            value: optionText.toLowerCase().replace(/\s+/g, '_'),
          };
          return {
            ...q,
            options: [...q.options, newOption],
          };
        }
        return q;
      });

      return { questions, isDirty: true };
    }),

  removeOption: (questionId, optionId) =>
    set((state) => ({
      questions: state.questions.map((q) => {
        if (q.id === questionId && q.options) {
          return {
            ...q,
            options: q.options.filter((opt) => opt.id !== optionId),
          };
        }
        return q;
      }),
      isDirty: true,
    })),

  updateOption: (questionId, optionId, updates) =>
    set((state) => ({
      questions: state.questions.map((q) => {
        if (q.id === questionId && q.options) {
          return {
            ...q,
            options: q.options.map((opt) =>
              opt.id === optionId ? { ...opt, ...updates } : opt
            ),
          };
        }
        return q;
      }),
      isDirty: true,
    })),
});